import FormsModalFormController from "../../../components/forms/assets/javascript/forms-modal-form-controller";
import { createCustomEvent } from "../../shared/helpers";

export default class extends FormsModalFormController {
  static targets = ['projectField', 'milestoneField'];

  connect() {
    super.connect()
    App.DynamicSelect.onChange(this.projectFieldTarget, this.updateMilestoneField.bind(this));
    this.updateMilestoneField(null, false);
  }

  handleSuccessfulFormSubmission(event, data) {
    super.handleSuccessfulFormSubmission(event, data)
    const { milestone } = this.parsedData(data);
    document.dispatchEvent(createCustomEvent("milestone:task-create:success", this.element, { listID: milestone }));
  }

  updateMilestoneField(event, clearValue=true) {
    event && event.preventDefault();
    if (clearValue) App.DynamicSelect.setValue(this.milestoneFieldTarget, null);
    App.DynamicSelect.setSelect2DataAttribute(this.milestoneFieldTarget, 'select2-ajax-url', this.milestoneURLWithProjectID);
  }

  parsedData(data) {
    try {
      const parsed = JSON.parse(data);
      return parsed;
    } catch(err) {
      return data
    }
  }

  //
  // GETTERS AND SETTERS
  //

    get milestoneURLWithProjectID() {
      return this.milestoneURL.replace('PROJECT_ID', this.projectFieldTarget.value);
    }

    get milestoneURL() {
      return this.data.get('milestone-url');
    }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/tasks/task-form-controller.js